<template>
  <div style="height: 100%">
    <SplitContainer3 style="height:100%" :layout="12" :split_setting1="0.42">
      <template #main>
        <TableMain name="one table" ref="ConsultQuoteTrackTable1" :fields="fields" :title="table_title.title1"
          :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
          :show_date_picker="true" :show_toolbar="false" :show_filter="true" date_picker_label="创建时间"
          :query_button_label="query_lable" :isBusy="isBusy" :show_toolbar_state="false"
          :only_text="$t('common.show_all')" :hb_table_class="'hb_table_cqe_class1'" @only_methods="only_methods"
          @on_query="on_query" :show_toolbar_button="[0, 0, 0, 0, 0]" :table_height_adjust="-6"
          @current_changed="current_changed" tableref="13245908b3894289ba2f6048b3921df6">
          <template #query>
            <el-input clearable size="small" style="width: 200px" placeholder="请输入询价单编号"
              v-model="ConsultQuoteNum"></el-input>
          </template>
          <template #toolbar>
            <el-popover placement="right" title="提示" width="250" trigger="hover" content="默认显示有未审批或未关闭的单据！"
              style="border-color: red;">
              <i slot="reference" class="el-icon-question ml-2" style="font-size:18px;margin-top: 6px;"></i>
            </el-popover>
          </template>
        </TableMain>
      </template>
      <template #top>
        <TableMain ref="ConsultQuoteTrackTable3" :fields="detail_fields" :show_query_container="false"
          :title="table_title.title3" :date_picker_label="date_picker_label" :table_height_adjust="8"
          :show_pagination="true" :show_toolbar="true" :show_filter="false" :pager_count="5" :isBusy="isBusy3"
          :loading_width="90" :show_toolbar_state="false" @state_change="state_change"
          :show_toolbar_button="[0, 0, 1, 0, 0, 0, 0, 0]" :show_close="true" :hb_table_class="'hb_table_track_class2'" tableref="43319d9111844cc4bc741b48b73dcfd2">
          <template #toolbar>
            <el-button type="primary" plain @click="getConsultDataBySelectedVend" class="ml-2 iconfont icon-search"
              size="mini">
              根据选中供应商查询询价响应情况
            </el-button>
          </template>
        </TableMain>
      </template>
      <template #bottom>
        <TableMain ref="ConsultQuoteTrackTable2" :show_query_container="false" :show_date_picker="false"
          :fields="consult_handle_fields" :table_height_adjust="2" :title="table_title.title2"
          :date_picker_label="date_picker_label" :query_button_label="query_lable" :show_toolbar="true" :pager_count="5"
          :isBusy="isBusy2" :show_toolbar_state="false" :show_toolbar_button="[0, 0, 0, 0, 1]"
          @state_change="state_change_vend_price" :hb_table_class="'hb_table_track_class1'"
          @on_cell_button_click="on_bottom_cell_button_click" tableref="f664e8179a9d484bb984fa5865009d5f">
          <template #toolbar>
            <el-button type="info" plain @click="createData()" class="ml-2 iconfont icon-add-new" size="mini">
              {{ $t("common.new") }}
            </el-button>
          </template>
        </TableMain>
      </template>
    </SplitContainer3>
    <!-- 新建报价 -->
    <el-drawer :title="'新建供应商报价'" :visible.sync="drawer" :with-header="true" :size="'65%'" :before-close="handleClose"
      @opened="DrawerOpend">
      <SplitContainer21 style="height:100%" :layout="12" :split_setting="0.5">
        <template #top>
          <TableMain ref="ConsultQuoteTrackingAddTable1" :fields="vend_price_add_fields" :show_query_container="false"
            :title="table_title.title2" :date_picker_label="date_picker_label" :table_height_adjust="8"
            :show_pagination="true" :show_filter="false" :pager_count="5" :isBusy="isBusy2" :show_toolbar="false"
            :loading_width="90" :hb_table_class="'hb_table_cqt_add_class1'" :show_toolbar_state="false" tableref="034bcc42ea1749bba788676dcbbf3ff2">
          </TableMain>
        </template>
        <template #bottom>
          <TableMain ref="ConsultQuoteTrackingAddTable2" :fields="consult_vend_price_return_fields"
            :show_query_container="false" :title="table_title.title3" :date_picker_label="date_picker_label"
            :table_height_adjust="2" :show_pagination="true" :show_toolbar="true" :show_filter="false" :pager_count="5"
            :isBusy="isBusy3" :loading_width="90" @state_change="detail_state_change"
            :show_toolbar_button="[0, 0, 0, 0, 1]" @on_input="on_input" :show_toolbar_state="false"
            :hb_table_class="'hb_table_cqt_add_class2'" tableref="225cf2cab49a432484bc572e4889f772">
            <template #toolbar>
              <el-select filterable clearable multiple collapse-tags reserve-keyword
                :placeholder="$t('common.provider')" class="ml-2" v-model="selected_venders" style="width: 25rem">
                <el-option v-for="(item, index) in vender_options" :key="index"
                  :label="item.AccountNum + ':' + item.SEI_Name" :value="item.AccountNum">
                </el-option>
              </el-select>
              <el-button type="info" plain style="width: 55px" class="ml-2" @click="AppendIntoDetail"><i
                  class="fa fa-plus"></i></el-button>
            </template>
            <template #operation>
              <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'"
                @on_query="Detail_SaveData" :label="$t('common.save')" class="ml-2"></QueryButton>
            </template>
          </TableMain>
        </template>
      </SplitContainer21>
    </el-drawer>
    <!-- 供应商附件管理 -->
    <el-dialog title="供应商附件列表" :visible.sync="accessoryVendVisible" width="60%" :top="'5vh'"
      :close-on-click-modal="false" @opened="bottomDialogOpened">
      <FileUpload ref="refVendAccessory" :accessoryCategory="'ConsultQuoteVend'" :showUpload="false"
        @setAccessory="bottomSetAccessory">
      </FileUpload>
    </el-dialog>
  </div>
</template>

<script>
import * as InventTableController from "../../controllers/base/InventTableController"
import * as ConsultQuoteConttroller from "../../controllers/mm/ConsultQuoteConttroller"
import * as VendInitialQuoteController from "../../controllers/sd/VendInitialQuoteController"
import QueryButton from "../components/base/QueryButton"
import SplitContainer21 from "../components/container/SplitContainer21"
import SplitContainer3 from "../components/container/SplitContainer3"
import TableMain from "../components/table/TableMain"
import FileUpload from "../FileUpload.vue"

export default {
  components: {
    SplitContainer3,
    SplitContainer21,
    TableMain,
    QueryButton,
    FileUpload
  },
  data() {
    return {
      drawer: false,
      date_picker_label: "",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_consult_quote",
        title2: "table_consult_quote_vend_price",
        title3: "table_consult_quote_vend",
      },
      cqe_modal_title: "",
      fields: _.cloneDeep(ConsultQuoteConttroller.fields.default),
      detail_fields: _.cloneDeep(ConsultQuoteConttroller.fields.consult_vend_fields),
      consult_handle_fields: _.cloneDeep(ConsultQuoteConttroller.fields.consult_handle_fields),
      vend_price_add_fields: _.cloneDeep(ConsultQuoteConttroller.fields.detail),
      consult_vend_price_return_fields: _.cloneDeep(ConsultQuoteConttroller.fields.consult_vend_price_return_fields),
      qt_modal_title: "",
      ConsultQuoteNum: "",
      isBusy: false,
      isBusy2: false,
      isBusy3: false,
      InventListHis: [],
      vend_consult_data_his: [],
      invent_retail_list: [],
      vender_options: [],
      selected_venders: [],
      query_date: [],
      filter_invent_name_key: "",
      filter_quote_task_key: "",
      current_vend_accessory: null,///当前供应商选中附件
      accessoryVendVisible: false,
    }
  },
  created() {
    this.fields = _.filter(this.fields, (t) => {
      return t.key != "is_valid" && t.key != "is_send_email"
    })
    this.detail_fields = _.filter(this.detail_fields, (t) => {
      if (t.key == "Description") delete t.editable
      return t.key != "DistributionRatio" && t.key != "DistributionDes"
    })

    this.consult_handle_fields = _.filter(this.consult_handle_fields, (t) => { return t.key != "Accessory" && t.key != "ConsultQuoteNum" && t.key != "LineNum" })


    let unIncludeFields = ["is_approved", "approved_by_username", "Accessory", "ConsultQuoteNum", "is_send_email"]
    this.vend_price_add_fields = _.filter(this.vend_price_add_fields, (t) => {
      delete t.editable
      return !_.includes(unIncludeFields, t.key)
    })

    this.consult_vend_price_return_fields = _.filter(this.consult_vend_price_return_fields, (t) => {
      return t.key != "Price_WOTax"
    })
  },
  mounted() {

  },
  methods: {
    only_methods(v) {
      this.on_query(this.$refs.ConsultQuoteTrackTable1.SetData, this.query_date, false)
    },
    async on_query(set_data, _date, isLoading = true) {
      if (isLoading) {
        this.isBusy = true
        set_data([])
      }

      let p = { is_deleted: { "=": 0 } }
      if (this.ConsultQuoteNum != "") {
        p.ConsultQuoteNum = { like: "%" + this.ConsultQuoteNum + "%" }
      } else if (_date && _date.length > 0) {
        this.query_date = _date
        let _fromDate = this.$date.format(_date[0], "yyyy-MM-dd")
        let _toDate = this.$date.format(_date[1], "yyyy-MM-dd")
        p["create_at"] = { ">=": _fromDate, "<=": _toDate }
      }

      let _result = await ConsultQuoteConttroller.methods.getData(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.filter(_.orderBy(_result[0], ["id"], ["desc"]), { is_valid: true, fcCheckCQHandleIsOk: true })
        dt.forEach((t) => {
          let _json = { quotation_task_num: "", cust_name: "", dataAreaIds: "" }
          if (t.fcGetConsultQuoteDetailInfo && t.fcGetConsultQuoteDetailInfo != "")
            _json = JSON.parse(t.fcGetConsultQuoteDetailInfo.replace(/\s+/g, ""))
          t.QuotationTaskNums = _json.quotation_task_num
          t.CustNames = _json.cust_name
          t.dataAreaIds = _json.dataAreaIds
        })
        if (!this.$refs.ConsultQuoteTrackTable1.only_value)
          dt = _.filter(dt, { fcCheckCQApprovedIsOk: false })
        _.each(dt, (t) => { t._error = !t.fcCheckCQApprovedIsOk })
        set_data(dt)
      }
      this.isBusy = false
    },
    async current_changed(old, current) {
      this.$refs.ConsultQuoteTrackTable2.SetData([])
      this.$refs.ConsultQuoteTrackTable3.SetData([])
      if (current) {
        this.isBusy2 = true
        await this.GetConsultVendPrice(current.id)
        this.isBusy2 = false
        this.isBusy3 = true
        await this.GetVendData(current)
        this.isBusy3 = false
      }
    },
    async GetVendData(current) {
      let p = { ConsultQuoteId: { "=": current.id }, is_deleted: { "=": 0 } }
      let _result = await ConsultQuoteConttroller.methods.getDataVend(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let detail_venders = []
        _.each(_result[0], (t) => {
          let m = _.find(_.cloneDeep(this.$store.state.biz_data.baseData.Vender), { AccountNum: t.AccountNum })
          m = Object.assign(m, t)
          // m.id = t.id;
          // m.Description = t.Description;
          // m.DistributionRatio = t.DistributionRatio;
          // m.is_approved = t.is_approved;
          // m.isRefused = t.isRefused;
          // m.is_done = t.is_done;
          if (t.is_approved)
            m.approved_by_username = t.approved_by_username
          if (m) detail_venders.push(m)
        })
        this.vender_options = _.cloneDeep(detail_venders)
        this.$refs.ConsultQuoteTrackTable3.SetData(_.orderBy(detail_venders, ["id"], ["asc"]))
        return detail_venders
      }
      return []
    },
    async GetConsultVendPrice(id, reset_table_data = true) {
      let _result = await ConsultQuoteConttroller.methods.getConsultVendPrice({ ConsultQuoteId: id })
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.cloneDeep(_result[0])
        _.each(dt, (t) => {
          t.AccessoryVendCount = 0
          if (t.VendAccessory && t.VendAccessory != "")
            t.AccessoryVendCount = JSON.parse(t.VendAccessory).length
        })
        if (reset_table_data) {
          this.vend_consult_data_his = dt
          this.$refs.ConsultQuoteTrackTable2.SetData(dt)
        }
        return dt
      }
      return []
    },
    async getConsultDataBySelectedVend() {
      this.$refs.ConsultQuoteTrackTable2.SetData([])
      let consult_order = this.$refs.ConsultQuoteTrackTable1.GetCurrentItem()
      let consult_vend_items = this.$refs.ConsultQuoteTrackTable3.GetSelectedItems()
      if (consult_vend_items.length > 0 && consult_order) {
        this.isBusy2 = true
        let vt = _.map(consult_vend_items, (t) => { return t.AccountNum })
        let dt = _.filter(this.vend_consult_data_his, (t) => {
          if (_.includes(vt, t.AccountNum)) return t
        })
        this.$refs.ConsultQuoteTrackTable2.SetData(dt)
        this.isBusy2 = false
      }
    },
    ///明细行输入事件
    distribution_on_input(data) {
      if (data.field.key == "DistributionRatio") {
        let lt = _.each(_.cloneDeep(this.$refs.ConsultQuoteTrackTable3.my_data), (t) => {
          if (!t.DistributionRatio) t.DistributionRatio = 0
          else t.DistributionRatio = parseFloat(t.DistributionRatio)

        })
        let total_rate = _.sumBy(lt, "DistributionRatio")
        if (total_rate > 100) {
          let _rate = 100 - (total_rate - data.item.DistributionRatio)
          data.item.DistributionRatio = _rate
        }
      }
    },
    on_input(data) {
      if (data.field.key == "Price") this.getWOTaxAmount(data.item)
    },
    getWOTaxAmount(item) {
      let _price = item.Price
      if (item.CurrencyCode != 'CNY') {
        let m = _.find(this.$store.state.biz_data.baseData.ExchangeRate, { dispFromCurrencyCode: item.CurrencyCode })
        if (m) _price = _price * (m.ExchangeRate / 100)
      }
      item.Price_WOTax = _price
      if (item.InclTax == '是') {
        let tg = _.find(this.$store.state.biz_data.baseData.TaxGroupHeading, { TaxGroup: item.TaxGroup, dataAreaId: "070" })
        item.Price_WOTax = _.round((_price / (1 + tg.SEI_TaxValue / 100)), 6)
      }
    },
    async state_change(data, cb) {
      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(false)
        return
      }
      let error_nums = [], approved_list = [], refused_list = []
      _.each(data.selected_items, (t) => {
        let _list = _.filter(this.vend_consult_data_his, { AccountNum: t.AccountNum })
        if (_list.length == 0) {
          error_nums.push(t.AccountNum)
        }
        if (t.is_approved && data.state == "approved")
          approved_list.push(t.AccountNum)
        if (t.is_approved && data.state == "refused")
          refused_list.push(t.AccountNum)
      })
      if (error_nums.length > 0) {
        this.msgToasts(_.join(error_nums, ",") + "号供应商暂无询价响应，不能执行该操作！", "info")
        return
      }
      else if (approved_list.length > 0) {
        this.msgToasts(_.join(approved_list, ",") + "号供应商已审批，请勿重复操作！", "info")
        return
      }
      else if (refused_list.length > 0) {
        this.msgToasts(_.join(refused_list, ",") + "号供应商已审批，不能执行该操作！", "info")
        return
      }

      let ask = await this.msgModal(this.$t("notify.is_continue"))
      if (!ask) {
        cb(false)
        return
      }
      ///查询相关变形编号
      // await this.getInventData();
      let p = {}
      if (data.state == "approved" || data.state == "unapproved") {
        let dt = _.each(data.selected_items, (t) => { t.is_approved = data.state == "approved" })
        p.approved = dt
      }
      else if (data.state == "refused") {
        let dt = _.map(data.selected_items, (t) => { return { id: t.id, isRefused: true } })
        p.edit = dt
      }
      else if (data.state == "closed") {
        let dt = _.map(data.selected_items, (t) => { return { id: t.id, is_done: true } })
        p.edit = dt
      }
      let rt = await ConsultQuoteConttroller.methods.saveDataVend(p)
      if (rt) {
        if (data.state == "approved") {
          for (var i in data.selected_items) {
            await this.saveToInitalPrice(data.selected_items[i].AccountNum)
          }
        }
        await this.GetVendData(this.$refs.ConsultQuoteTrackTable1.GetCurrentItem())
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        cb(true)
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        cb(false)
      }
    },
    async state_change_vend_price(data, cb) {
      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(false)
        return
      }
      let ask = await this.msgModal(this.$t("notify.is_continue"))
      if (!ask) {
        cb(false)
        return
      }
      let p = {}
      if (data.state == "deleted") {
        p.delete = data.selected_items
      }
      let rt = await ConsultQuoteConttroller.methods.saveDataVendQuoteFromConsult(p)
      if (rt) {
        await this.GetConsultVendPrice(this.$refs.ConsultQuoteTrackTable1.GetCurrentItem().id)
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        cb(true)
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        cb(false)
      }
    },
    ///保存至供应商初始报价
    async saveToInitalPrice(AccountNum) {
      const price_data = await this.GetConsultVendPrice(this.$refs.ConsultQuoteTrackTable1.GetCurrentItem().id, false)
      let _this = this
      let _list = _.cloneDeep(_.filter(price_data, { AccountNum: AccountNum }))
      let _items = []
      _.each(_list, (t) => {
        let mt = {}
        let _data = _.cloneDeep(t)
        mt.SEI_Name = _data.AccountName
        mt.FromDate = _this.$date.format(new Date(), "yyyy-MM-dd")
        mt.ToDate = "2099-12-31"
        mt.ItemId = _data.ItemId
        mt.NameAlias = _data.NameAlias
        mt.AccountNum = _data.AccountNum
        mt.ConsultQuoteVendPriceId = _data.id
        mt.QuantityAmountFrom = _data.FromQty
        mt.QuantityAmountTo = _data.ToQty
        mt.Amount = _data.Price
        mt.CurrencyCode = _data.CurrencyCode
        mt.TaxGroup = _data.TaxGroup
        mt.AmountWOTax = _data.Price_WOTax
        mt.Transport = _data.Transport
        mt.quotationType = _data.quotationType
        mt.create_by_username = this.$global.global_data.local_username
        _items.push(mt)
      })

      ///保存数据
      let rt = await VendInitialQuoteController.methods.saveDataDefaultApproved(_items)
      if (!_.isNull(rt)) { }
    },
    ///获取物料相关信息
    async getInventData() {
      let ItemIds = _.uniqWith(_.map(this.$refs.ConsultQuoteTrackTable2.my_data, (t) => { return { ItemId: t.ItemId, } }), _.isEqual)

      let _result = await InventTableController.methods.getItemData(ItemIds)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let _list = _.filter(_result[0], (t) => {
          return t.RetailVariantId != ""
        })
        this.invent_retail_list = _list
      }
    },
    createData() {
      let consult_order = this.$refs.ConsultQuoteTrackTable1.GetCurrentItem()
      if (!consult_order) {
        this.msgToasts("请选择询价单！", "info")
        return
      }
      this.drawer = true
    },
    handleClose(done) {
      this.$confirm('确认关闭？').then(t => {
        this.$refs.ConsultQuoteTrackingAddTable2.SetData([])
        done()
      }).catch(t => { })
    },
    async DrawerOpend() {
      let consult_order = this.$refs.ConsultQuoteTrackTable1.GetCurrentItem()
      await this.Detail_Query(consult_order.id)
    },
    ///查询报价明细
    async Detail_Query(QTId) {
      let p = { ConsultQuoteId: QTId }
      let _result = await ConsultQuoteConttroller.methods.getDetailDataSql(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.$refs.ConsultQuoteTrackingAddTable1.SetData(_.orderBy(_result[0], ["LineNum"], ["asc"]))
      }
    },
    AppendIntoDetail() {
      let consult_detail_selected_items = this.$refs.ConsultQuoteTrackingAddTable1.GetSelectedItems()
      if (consult_detail_selected_items.length == 0) {
        this.msgToasts("请选择询价单明细！", "info")
        return
      }
      else if (this.selected_venders.length == 0) {
        this.msgToasts("请选择供应商！", "info")
        return
      }
      let dt = _.cloneDeep(this.$refs.ConsultQuoteTrackingAddTable2.my_data)
      _.each(_.cloneDeep(consult_detail_selected_items), (t1) => {
        delete t1._current
        delete t1._selected
        delete t1._id
        delete t1._rowVariant
        _.each(this.selected_venders, (AccountNum) => {
          let m = _.find(this.vender_options, { AccountNum: AccountNum })
          t1.AccountNum = AccountNum
          t1.AccountName = m.SEI_Name
          t1.InclTax = m.InclTax
          t1.CurrencyCode = m.Currency
          t1.TaxGroup = m.TaxGroup
          t1.Description = ""
          let isExists = _.findIndex(dt, { ItemId: t1.ItemId, AccountNum: t1.AccountNum, FromQty: t1.FromQty, ToQty: t1.ToQty, LineNum: t1.LineNum }) < 0
          if (isExists) dt.push(_.cloneDeep(t1))
        })
        this.$refs.ConsultQuoteTrackingAddTable2.SetData(dt)
      })
    },
    detail_state_change(data, cb) {
      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(false)
        return
      }
      if (data.state === "deleted") {
        this.$refs.ConsultQuoteApplyTable3.RemoveItems(data.selected_items)
      }
    },
    async Detail_SaveData(cb) {
      let dt = _.cloneDeep(this.$refs.ConsultQuoteTrackingAddTable2.my_data)
      if (dt.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(false)
        return
      }

      let p = { json: "" }, m = { data: [] }
      _.each(dt, (t) => { t.ConsultQuoteDetailId = t.id })
      m.data = dt
      p.json = JSON.stringify(m)
      let rt = await ConsultQuoteConttroller.methods.saveVendPriceFromConsult(p)
      if (rt) {
        await this.GetConsultVendPrice(this.$refs.ConsultQuoteTrackTable1.GetCurrentItem().id)
        this.$refs.ConsultQuoteTrackingAddTable2.SetData([])
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        cb(true)
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        cb(false)
      }
    },
    //#region 供应商附件
    async on_bottom_cell_button_click(data) {
      this.current_vend_accessory = data.item
      if (data.field.key == "VendAccessory") {
        this.accessoryVendVisible = true
      }
    },
    bottomDialogOpened() {
      this.$refs.refVendAccessory.getAccessory(this.current_vend_accessory.VendAccessory, this.current_vend_accessory.ItemId)
    },
    bottomSetAccessory(data) {
      this.current_vend_accessory.Accessory = data
    }
    //#endregion
  },
}
</script>
<style>
.hb_table_cqe_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 70rem;
}

.hb_table_track_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 230rem;
}

.hb_table_track_class2 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 80rem;
}

.hb_table_cqt_add_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 185rem;
}

.hb_table_cqt_add_class2 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 145rem;
}
</style>
